/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesConsequences.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Consequence Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 12:43:41 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const ConsequenceList = Loadable({
    loader: () => import('../containers/Consequences/ConsequenceListContainer'),
    loading: Loading,
});

export const ConsequenceForm = Loadable({
    loader: () => import('../containers/Consequences/ConsequenceEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesConsequences.js